import { useQuery } from "@tanstack/react-query";

import { fetchRouteMapData } from "../../api/routes";

export function useFetchRouteMapData(filters = {}) {
  return useQuery({
    queryKey: ["routes", "map-data", filters],
    queryFn: () => fetchRouteMapData(filters),
    onError: (error) => console.error("Error loading route map data:", error),
  });
}
